/* eslint-env browser */
import { atom } from 'recoil';
import sessionStorageEffect from '../effects/sessionStorageEffect';

const KEY = 'gateway_api_url';

function determineGateway() {
  if (window.localStorage.gatewayUrl) {
    return window.localStorage.gatewayUrl;
  }

  const url = window.location.host.toLowerCase();

  if (url.match(/points.skout.com/)) {
    return 'https://api.gateway.skoutapis.com';
  }

  if (url.match(/rewards.skoutstage.com/)) {
    return 'api.gateway.skoutstage.com';
  }

  if (url.match(/(?:credits|points|gold|subscriptions|rewards)\.video\.[a-z]+-live(stage)?\.com/)) {
    return `https://${url.replace(/(?:credits|points|gold|subscriptions|rewards)\.video/, 'api.gateway')}`;
  }

  if (url.match(/credits.*/)) {
    return `https://${url.replace('credits', 'api.gateway')}`;
  }

  if (url.match(/subscriptions.*/)) {
    return `https://${url.replace('subscriptions', 'api.gateway')}`;
  }

  if (url.match(/rewards.*/)) {
    return `https://${url.replace('rewards', 'api.gateway')}`;
  }

  return 'https://api.gateway.mtmestage.com';
}

export default atom({
  key: 'gatewayApiUrl',
  default: determineGateway(),
  effects: [
    sessionStorageEffect(KEY),
  ],
});
